// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2952":"e7417176","4538":"e7417176","4878":"e7417176","5831":"e7417176"}[chunkId] + ".chunk.css";
};